define((require) => {
    "use strict";

    var ImprovedModel = require("shared/zbone/ImprovedModel");

    /**
     * A widget object is both the icon in the widget library and the element on the scene in an
     * experience.
     *
     * @class Widget
     * @constructor
     */
    return ImprovedModel.extend("Widget", {

        embedded: true, // since it has an id and we do not want to call the server on sync.

        defaults: {
            type: null
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/Widget.js